import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ProductViewDataService } from  './../../shared-postlogin/services/product-view-data.service';
import { ApiGatewayHelperService } from './../../app/services/apigateway-helper.service';
import { AuthService } from '../../app/services/auth.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';


@Injectable()
export class CreateAccessResolverService  {
    constructor(private authService: AuthService,
        private productViewDataService: ProductViewDataService,
        private appHelperService: AppHelperService,
        private apiGatewayHelperService : ApiGatewayHelperService) { }
    
    resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
        this.apiGatewayHelperService.setSpaceId(route.params.spaceid);
        const productCode = route.params.productcode;
        const userData = this.authService.getUserData();
        const classId = route.params.classid;
        const ruleId = route.params.ruleid;
        return this.productViewDataService.fetchAndStoreProductViewData({productCode, classId}, true, false, ruleId || 'allRules').toPromise().then((productData: any)=> {

            if (productData && productData.success === false) {
                this.appHelperService.showLoaderAndNavigateToDashboard(userData);
                return;
            }
            // NEMO-6677 : navigate away to dashboard as the product is suppressed.
            const bundleDetails = productData['bundleDetails'];
            const product = bundleDetails && bundleDetails.products && bundleDetails.products.find((bundle) => bundle['dls-product'] && bundle['dls-product'].code === productCode);
            if (this.productViewDataService.isProductSuppressed(product, 'hide-learning-path', route.params.spaceid)) {
                this.appHelperService.navigateToDashboardApp([]);
            }

            return {
                'userProfileData': userData,
                'productData': productData
            }
        });
    }
}
